import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { handleSender } from '@/store/slices/components/sender/SenderSlice';
import { showTokkoChat } from '@/store/slices/components/chat/MessengerSlice';
import MessengerService from '@/services/MessengerService';

export default function useWhatsappOrSender({ contactId }) {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const { plan_type_features } = useSelector(
    (state) => state.AuthSlice.permissions
  );

  const WHATSAPP_PLAN = plan_type_features.includes('whatsapp_integration');

  const getContactChatOrSender = async () => {
    try {
      setLoading(true);
      const res = await MessengerService.getContactChatOrSender(contactId);
      setLoading(false);

      if (res.open_tokko_chat) {
        dispatch(showTokkoChat({ show: true, CID: res.channel_cid }));
        return true;
      }

      return false;
    } catch (error) {
      setLoading(false);
      return false;
    }
  };

  const handleWhatsappAction = async () => {
    if (WHATSAPP_PLAN) {
      const isOpen = await getContactChatOrSender();
      if (isOpen) {
        return;
      }
    }

    dispatch(
      handleSender({
        show: 'whatsapp',
        preSelectedContacts: [contactId],
      })
    );
  };

  return { loading, handleWhatsappAction };
}
